module.exports = __webpack_public_path__ + "Icono_ListaPrecio-Bco_512px.png";